import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { NouisliderModule } from "ng2-nouislider";
import { UiSwitchModule } from "angular2-ui-switch";
import {
  ButtonModule,
  RadioButtonModule,
  CheckboxModule,
  GrowlModule
} from "primeng/primeng";

import { AccountComponent } from "./account/account.component";
import { ActionsComponent } from "./security/actions.component";
import { FormInputComponent } from "./account/form-input.component";
import { MySettingsComponent } from "./my-settings.component";
import { NotificationSettingsComponent } from "./notification/notification-settings.component";
import { SecurityComponent } from "./security/security.component";
import { GoogleAuthSetupWizComponent } from "./security/GoogleAuthenticatorSetupWizard.component";
import { SecuritySettingsComponent } from "./security/security-settings.component";

import {
  AccountService,
  AccountViewService,
  UserNavSecurityService,
  MfaOptionsViewService,
  MfaOptionsSaveService,
  MfaOptionsQRCodeService,
  GoogleAuthValidatorService,
  LocalizationService,
  DeletePendingEmailService
} from "./account/account.service";
import { HttpDataService } from "./http-data.service";
import { NotificationSettingService } from "./notification/notification-settings.service";
import { PhoneVerificationService } from "./account/phone-verify.service";

import { MySettingsRoutingModule } from "./my-settings-routing.module";
import { VerificationStatePipe } from "./account/verification-state.pipe";
import { TimeService } from "./time.service";
import { NotificationHeadersPipe } from "./notification/notificationHeader.pipe";
import { TranslateModule } from '@ngx-translate/core';
import { NgxTranslateService } from "./shared/ngx-translate.service";

@NgModule({
  imports: [
    ButtonModule,
    CheckboxModule,
    RadioButtonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GrowlModule,
    HttpModule,
    NouisliderModule,
    UiSwitchModule,
    MySettingsRoutingModule,

    TranslateModule.forChild(),
  ],
  exports: [MySettingsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AccountComponent,
    ActionsComponent,
    FormInputComponent,
    MySettingsComponent,
    NotificationSettingsComponent,
    SecurityComponent,
    SecuritySettingsComponent,
    GoogleAuthSetupWizComponent,
    VerificationStatePipe,
    NotificationHeadersPipe
  ],
  providers: [
    AccountService,
    AccountViewService,
    MfaOptionsViewService,
    MfaOptionsSaveService,
    HttpDataService,
    NotificationSettingService,
    PhoneVerificationService,
    TimeService,
    UserNavSecurityService,
    MfaOptionsQRCodeService,
    GoogleAuthValidatorService,
    NgxTranslateService,
    LocalizationService,
    DeletePendingEmailService
  ]
})
export class MySettingsModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/my-settings.module.ts